import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IOrderModel } from '@apps-common/types/management/order'

export const cancelOrder = async (orderId: string): Promise<IOrderModel> =>
  axios.delete(`/management/order/cancelorder?orderId=${orderId}`).then((res) => res?.data?.data)

type Props = {
  orderId: string
}

export const useManagementCancelOrder = (notify?: boolean, onSuccess?: (data: IOrderModel) => void) =>
  useMutation({
    mutationKey: ['cancelOrder'],
    mutationFn: ({ orderId }: Props) => cancelOrder(orderId),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Cancelled order.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to cancel order, please try again.')
      }
    },
    throwOnError: false
  })
